import { forwardRef } from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import {
  type TDrawerDescriptionElement,
  type TDrawerDescriptionProps,
} from "@/ui/components/overlay/Drawer/Drawer.config";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib";

export const DrawerDescription = forwardRef<TDrawerDescriptionElement, TDrawerDescriptionProps>(
  ({ className, children, ...props }, ref) => (
    <DrawerPrimitive.Description
      data-component="DrawerDescription"
      ref={ref}
      className={cn("text-foreground-muted-strong", className)}
      {...props}
    >
      <TextBody tag="span" size={2} isResponsive={false} color="inherit" align="center" className="block">
        { children }
      </TextBody>
    </DrawerPrimitive.Description>
  ),
);

DrawerDescription.displayName = "DrawerDescription";
